import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { SqlService } from "../../Database/sql.service";

import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
//import { typeWithParameters } from '@angular/compiler/src/render3/util';

import Swal from 'sweetalert2';


@Component({
  selector: 'app-allocate-client',
  templateUrl: './allocate-client.component.html',
  styleUrls: ['./allocate-client.component.css']
})
export class AllocateClientComponent implements OnInit {


  firstscreen = true;
  Secondscreen = false;
  confirmed = false;

  BoxNumberBatchsize = 0;

  BoxNumber = "";
  Batchsize = 2;
  CurrentBatch = 1;
  Boxsize = 0;
  Province = "";

  Data = [{ Client: "", Area: "" }];
  Clients = [[""]];
  Areas = [""];

  InputClients = [""];
  InputAreas = [""];
  InputDate = [""];
  SavedBatches: boolean[] = [];
  MinDateOption = "";

  CurrentDate = "";

  PossibleBoxNumbers = [""];
  PossibleBox = "";

  PopUpbtnText = "Done";

  constructor(private dbService: SqlService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.GetAllBoxNames(" Status = 'Allocated' OR status= 'Done' ");

    const today = new Date();
    const oneYearAgo = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());

    // Format the date to 'yyyy-MM-dd' as required by HTML date input's min attribute
    this.MinDateOption = oneYearAgo.toISOString().split('T')[0];
    this.InputDate[0] = today.toISOString().split('T')[0];

    let tempDate = new Date();
    this.CurrentDate = tempDate.getFullYear() + "-";
    let monthTemp = Number.parseInt(tempDate.getMonth().toString());
    monthTemp++;
    if (tempDate.getMonth().toString().length == 1) {
      this.CurrentDate += "0" + monthTemp + "-";
    } else {
      this.CurrentDate += monthTemp + "-";
    }

    if (tempDate.getDate().toString().length == 1) {
      this.CurrentDate += "0" + tempDate.getDate();
    } else {
      this.CurrentDate += tempDate.getDate();
    }
  }

  PossibleBoxChanged() {
    this.BoxNumber = this.PossibleBox[0];
  }

  TimeOutForInputBoxNumber: any = null;

  BoxNameChanged(event: any) {
    clearTimeout(this.TimeOutForInputBoxNumber);
    var $this = this;
    this.TimeOutForInputBoxNumber = setTimeout(function () {
      $this.executeSearchForPossibleBoxNumbers(event.target.value);
    }, 500);
  }

  executeSearchForPossibleBoxNumbers(value: string) {
    this.GetAllBoxNames(" ( Status = 'Allocated' OR status= 'Done' ) AND ([Pactel].[dbo].[Boxes].Boxno like '" + value + "%') ");
  }


  GetAllBoxNames(condition: string) {
    Swal.fire({
      title: 'Loading Boxes',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });


    this.PossibleBoxNumbers.splice(0);


    let formData = new FormData(); // Currently empty
    formData.set("Where", condition);


    (this.dbService.getTopBoxesNames(formData).subscribe((ret: any) => {
      if (ret != "false") {
        (ret as string).split(';').forEach(element => {
          this.PossibleBoxNumbers.push(element);
        });

        Swal.close();
      } else {
        this.PopupTitle = "Error"
        this.DisplayErrormessage = "Please check your internet connection and try again";
        let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        element.click();
        Swal.close();
      }
    }));
  }



  Reset() {
    this.firstscreen = true;
    this.Secondscreen = false;
    this.BoxNumber = "";

    this.GetAllBoxNames(" Status = 'Allocated' OR status= 'Done' ");
  }

  ResetClients() {
    // Preserve saved batches; only reset editable (unsaved) batch inputs
    // Ensure arrays have entries up to BoxNumberBatchsize
    while (this.InputClients.length < this.BoxNumberBatchsize) this.InputClients.push("");
    while (this.InputAreas.length < this.BoxNumberBatchsize) this.InputAreas.push("");
    while (this.InputDate.length < this.BoxNumberBatchsize) this.InputDate.push(new Date().toISOString().split('T')[0]);
    while (this.Clients.length < this.BoxNumberBatchsize) this.Clients.push([]);

    for (let i = 0; i < this.BoxNumberBatchsize; i++) {
      if (this.SavedBatches[i]) continue; // keep saved values
      this.InputClients[i] = "";
      this.InputAreas[i] = "";
      this.InputDate[i] = new Date().toISOString().split('T')[0];
      this.Clients[i] = [];
    }
  }


  async Next() {
    Swal.fire({
      title: 'Loading Box Details',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });

    await (this.dbService.GetBoxDetails(this.BoxNumber).subscribe((ret: any) => {
      if (ret != "false") {
        let a = (ret as string).split(';');
        a.splice(a.length - 1, 1);

        let firsttemp = a[0].split(",");
        //this.Boxsize = Number.parseInt(firsttemp[0]); -> BoxSizeDirect
        //this.Batchsize = Number.parseInt(firsttemp[1]); -> BatchSizeDirect
        this.Boxsize = Number.parseInt(firsttemp[2]); // BoxSizeInDirect
        this.Batchsize = Number.parseInt(firsttemp[3]); // BatchSizeInDirect
        //this.Status = firsttemp[4];
        //this.branch = firsttemp[5];
        this.Province = firsttemp[6];


        a.splice(0, 1);

        this.BoxNumberBatchsize = 1;
        a.forEach(element => {
          let secondtemp = element.split(",");
          let temp = {
            SerialNumber: secondtemp[0],
            BatchNo: secondtemp[1],
            Client: secondtemp[2],
            DateDist: secondtemp[3],
            ClientArea: secondtemp[5]
          }
          this.InputAreas[Number(temp.BatchNo) - 1] = temp.ClientArea;

          if (temp.ClientArea.length > 2) {
            this.InputClients[Number(temp.BatchNo) - 1] = temp.Client;
          }


          if( temp.DateDist=="1900-01-01"){
            this.InputDate[Number(temp.BatchNo) - 1] = new Date().toISOString().split('T')[0];
          }else{
            this.InputDate[Number(temp.BatchNo) - 1] = temp.DateDist;
          }

          // initialize saved state for this batch if DB already has data
          if (this.SavedBatches.length < (Number(temp.BatchNo))) {
            // ensure array large enough
            while (this.SavedBatches.length < (Number(temp.BatchNo))) this.SavedBatches.push(false);
          }
          if ((temp.Client && temp.Client.length > 0) || (temp.ClientArea && temp.ClientArea.length > 0) || (temp.DateDist && temp.DateDist != "1900-01-01")) {
            this.SavedBatches[Number(temp.BatchNo) - 1] = true;
          }


          if (Number(temp.BatchNo) > this.BoxNumberBatchsize) {
            this.BoxNumberBatchsize = Number(temp.BatchNo);
          }
        });

        Swal.close();
        if (firsttemp[4] == "Allocated" || firsttemp[4] == "Done") {
          this.getClientsPerArea();
        } else {
          this.PopupTitle = "Error"
          this.DisplayErrormessage = "Box has invalid status:'" + firsttemp[4] + "', when it should be 'Allocated' or 'Done'";
          let element: HTMLButtonElement = document.getElementById('contentClientPopUpErrorButton') as HTMLButtonElement;
          element.click();
        }


      } else {
        Swal.close();
        this.PopupTitle = "Error"
        this.DisplayErrormessage = "Please check your box number try again";
        let element: HTMLButtonElement = document.getElementById('contentClientPopUpErrorButton') as HTMLButtonElement;
        element.click();
      }


    }));
  }


  getClientsPerArea() {
    var formData = new FormData(); // Currently empty 
    formData.set("Province", this.Province);

    Swal.fire({
      title: 'Loading Client List',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });

    this.dbService.getClientsPerProvince(formData).subscribe((ret: any) => {
      this.Data.splice(0);
      //this.Clients.splice(0);

      this.Areas.splice(0);

      //this.Areas.push("All");

      if (ret != "false") {
        let a = (ret as string).split(';');
        a.splice(a.length - 1, 1);



        a.forEach(element => {
          let firsttemp = element.split(",");
          let temp = { Client: firsttemp[0], Area: firsttemp[1] };

          if (!(this.Data.includes(temp))) {
            this.Data.push(temp);

            if (!(this.Areas.includes(temp.Area))) {
              this.Areas.push(temp.Area);
            }

          }

        });

        for (let batchIndex = 0; batchIndex < this.BoxNumberBatchsize; batchIndex++) {
          if ((this.InputClients[batchIndex] || "").length > 2) {
            this.AreaChanged(batchIndex, true);
          }
        }



        this.firstscreen = false;
        this.Secondscreen = true;
        Swal.close();
        return true;
      } else {
        this.PopupTitle = "Error"
        this.DisplayErrormessage = "Something went wrong, please try again. If this continues please contact the I.T Department";
        let element: HTMLButtonElement = document.getElementById('contentClientPopUpErrorButton') as HTMLButtonElement;
        element.click();
        Swal.close();
        return false;
      }


    });
  }

  DateChanged(pos: number) {
    if (pos == 0) {
      Swal.fire({
        title: 'Updating All Date Inputs',
        showConfirmButton: false,
        toast: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        willOpen: () => {
          Swal.showLoading();
        }
      });

      for (let index = 1; index < this.BoxNumberBatchsize; index++) {
        if (!this.SavedBatches[index]) {
          this.InputDate[index] = (this.InputDate[0]);
        }
      }

      Swal.close();
    }
  }

  AreaChanged(pos: number, initSetup = false) {

    Swal.fire({
      title: 'Updating Area Inputs',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });

    //InputAreas[pos]
    this.Clients[pos] = [];

    this.Data.filter((x) => x.Area == this.InputAreas[pos]).forEach(element => {
      if (element.Area == this.InputAreas[pos]) {
        this.Clients[pos].push(element.Client);
      }
    });

    if (initSetup == false) {
      for (let index = (pos); index < this.BoxNumberBatchsize; index++) {
        if (!this.SavedBatches[index]) {
          this.InputAreas[index] = (this.InputAreas[pos]);
          this.Clients[index] = this.Clients[pos].sort();
        }
      }

    }

    Swal.close();
  }


  async Done() {
    // Allow partial saves: only update batches that have both Client and Date set and are not already saved
    const updates: number[] = [];
    for (let index = 0; index < this.BoxNumberBatchsize; index++) {
      const client = (this.InputClients[index] || "").toString().trim();
      const date = (this.InputDate[index] || "").toString().trim();
      const area = (this.InputAreas[index] || "").toString().trim();
      // batch is valid only if Area, Client and Date are provided
      if (area.length > 0 && client.length > 0 && date.length > 0) {
        updates.push(index);
      }
    }

    if (updates.length === 0) {
      this.confirmed = false;
      this.PopupTitle = "Invalid data"
      this.DisplayErrormessage = "No completed batches to save. Fill Area, Client and Date for at least one batch.";
      let element: HTMLButtonElement = document.getElementById('contentClientPopUpErrorButton') as HTMLButtonElement;
      element.click();
      return;
    }

    if (this.confirmed == false) {
      this.PopupTitle = "Confirmation"
      this.DisplayErrormessage = "Please read through all entered details, and once happy select the 'Save' button";
      this.PopUpbtnText = "Okay"
      let element: HTMLButtonElement = document.getElementById('contentClientPopUpErrorButton') as HTMLButtonElement;
      element.click();
      this.confirmed = true;
      return;
    }

    Swal.fire({
      title: 'Saving Data',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });

    // build SQL for all completed batches (Area, Client, Date present), including previously saved
    let strSQL = "";
    updates.forEach(index => {
      strSQL += "UPDATE [Pactel].[dbo].[BoxDetails] SET Province='" + this.Province + "' , Client='" + this.InputClients[index] + "', ClientArea='" + this.InputAreas[index] + "' , DateDist = '" + this.InputDate[index] + "' WHERE Boxno='" + this.BoxNumber + "' AND Batchno = '" + (index + 1) + "';";
    });

    const formData = new FormData();
    formData.set("SQL", strSQL);

    await (this.dbService.FinishBox(formData).subscribe(async (ret: any) => {
      if (ret != "false") {
        // mark updated batches as saved
        updates.forEach(index => this.SavedBatches[index] = true);

        // if all batches are now saved, mark box as Done
        const allSaved = this.SavedBatches.length >= this.BoxNumberBatchsize && this.SavedBatches.every(x => x === true);
        if (allSaved) {
          const f2 = new FormData();
          f2.set("SQL", "UPDATE [Pactel].[dbo].[Boxes] SET Status='Done' WHERE Boxno='" + this.BoxNumber + "';");
          await (this.dbService.FinishBox(f2).subscribe((ret2: any) => {
            Swal.close();
            if (ret2 != "false") {
              this.PopupTitle = "Success"
              this.DisplayErrormessage = "The box has been closed";
              let element: HTMLButtonElement = document.getElementById('contentClientPopUpErrorButton') as HTMLButtonElement;
              element.click();
              this.Reset();
            } else {
              this.confirmed = false;
              this.PopupTitle = "Error"
              this.DisplayErrormessage = "Please check your box number try again";
              let element: HTMLButtonElement = document.getElementById('contentClientPopUpErrorButton') as HTMLButtonElement;
              element.click();
            }
          }));
        } else {
          Swal.close();
          this.PopupTitle = "Success"
          this.DisplayErrormessage = "Saved " + updates.length + " batch(es).";
          let element: HTMLButtonElement = document.getElementById('contentClientPopUpErrorButton') as HTMLButtonElement;
          element.click();
        }

        this.confirmed = false;
      } else {
        Swal.close();
        this.confirmed = false;
        this.PopupTitle = "Error"
        this.DisplayErrormessage = "Please check your box number try again";
        let element: HTMLButtonElement = document.getElementById('contentClientPopUpErrorButton') as HTMLButtonElement;
        element.click();
      }
    }));

  }
  



  AddNewArea() {
    let element: HTMLButtonElement = document.getElementById('AddAreaButton') as HTMLButtonElement;
    element.click();

    let element2: HTMLButtonElement = document.getElementById('AddAreaBackBtn') as HTMLButtonElement;
    element2.hidden = true;

    let elementContainer: HTMLDivElement = document.getElementById('AddAreaContainer') as HTMLDivElement;
    elementContainer.style.width = "";
  }

  AddNewClient() {
    let element: HTMLButtonElement = document.getElementById('AddClientButton') as HTMLButtonElement;
    element.click();

    let element2: HTMLButtonElement = document.getElementById('AddClientBackBtn') as HTMLButtonElement;
    element2.hidden = true;

    let elementContainer: HTMLDivElement = document.getElementById('AddClientContainer') as HTMLDivElement;
    elementContainer.style.width = "";
  }


  async getUpdatedClientsList() {
    var formData = new FormData(); // Currently empty 
    formData.set("Province", this.Province);

    Swal.fire({
      title: 'Loading Updated Client List',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });

    await (this.dbService.getClientsPerProvince(formData).subscribe((ret: any) => {
      this.Data.splice(0);
      //this.Clients.splice(0);

      this.Areas.splice(0);
      //this.Areas.push("All");

      if (ret != "false") {
        let a = (ret as string).split(';');
        a.splice(a.length - 1, 1);

        a.forEach(element => {
          let firsttemp = element.split(",");
          let temp = { Client: firsttemp[0], Area: firsttemp[1] };

          if (!(this.Data.includes(temp))) {
            this.Data.push(temp);

            if (!(this.Areas.includes(temp.Area))) {
              this.Areas.push(temp.Area);
            }
          }
        });
        this.AreaChanged(0);
        Swal.close();
      } else {
        this.PopupTitle = "Error"
        this.DisplayErrormessage = "Something went wrong, please try again. If this continues please contact the I.T Department";
        let element: HTMLButtonElement = document.getElementById('contentClientPopUpErrorButton') as HTMLButtonElement;
        element.click();
      }
    }));
  }

  // Returns true when there are any batches that are not yet saved
  HasUnsavedBatches(): boolean {
    if (this.BoxNumberBatchsize <= 0) return false;
    for (let i = 0; i < this.BoxNumberBatchsize; i++) {
      if (this.SavedBatches[i] !== true) return true;
    }
    return false;
  }

  // When the date input receives focus, default it to today if empty
  SetDateIfEmpty(pos: number) {
    if (pos == null || pos < 0) return;
    // ensure array long enough
    while (this.InputDate.length <= pos) this.InputDate.push("");
    if (!this.InputDate[pos] || this.InputDate[pos] === "") {
      const today = new Date();
      const pad = (n: number) => (n < 10 ? '0' + n : n.toString());
      this.InputDate[pos] = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
    }
  }

  // number of completed (saved) batches
  get CompletedCount(): number {
    if (this.BoxNumberBatchsize <= 0) return 0;
    let count = 0;
    for (let i = 0; i < this.BoxNumberBatchsize; i++) {
      if (this.SavedBatches[i] === true) count++;
    }
    return count;
  }

  get CompletedSummary(): string {
    return this.BoxNumberBatchsize > 0 ? `${this.CompletedCount} out of ${this.BoxNumberBatchsize} batches completed` : '';
  }


  closeResult = '';
  DisplayErrormessage = "";
  PopupTitle = "";
  open(content: any) {
    this.modalService.open(content,
      { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = 'Closed with: ${result}';
      }, (reason) => {
        this.closeResult =
          'Dismissed ${this.getDismissReason(reason)}';
        //let element: HTMLButtonElement = document.getElementById('contentClientPopUpErrorButton') as HTMLButtonElement;
        //element.click();
      });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return 'with: ${reason}';
    }
  }


  opentemplate(content: any) {
    this.modalService.open(content,
      { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = 'Closed with: ${result}';
        this.Next();
        this.getUpdatedClientsList();


      }, async (reason) => {
        this.closeResult =
          'Dismissed ${this.getDismissReason(reason)}';
        this.Next();
        this.getUpdatedClientsList();
        //let element: HTMLButtonElement = document.getElementById('contentClientPopUpErrorButton') as HTMLButtonElement;
        //element.click();
      });
  }
}
